import { track } from "@amplitude/analytics-react-native";
import { useCallback } from "react";
import { useGatheringStore } from "src/contexts/GatheringContext";
import { useModal } from "src/modals";
import GatheringModal from "src/modals/configs/GatheringModal";

const usePresentAdminPrivacy = ({ amplitudeEvent }: { amplitudeEvent?: string } = {}) => {
	const gatheringId = useGatheringStore((state) => state.gatheringId);
	const { presentModal } = useModal<GatheringModal>();

	const handlePresentAdminPrivacy = useCallback(async () => {
		if (amplitudeEvent) {
			track(amplitudeEvent);
		}
		presentModal("GatheringAdminPrivacy", {
			props: {
				gatheringId,
			},
		});
	}, [amplitudeEvent, presentModal, gatheringId]);
	return {
		handlePresentAdminPrivacy,
	};
};
export default usePresentAdminPrivacy;
